export default function phonenumberfix(md) {
    const originalStrongOpenRenderer = md.renderer.rules.strong_open;
    const originalStrongCloseRenderer = md.renderer.rules.strong_close;

    md.renderer.rules.strong_open = (tokens, idx, options, env) => {
        if(tokens.length >= idx+1) {
            const token = tokens[idx+1];
            if(token.type === 'text' && /^[\d#+]+$/.test(token.content)) {
                return '**';
            }
        }
        return originalStrongOpenRenderer(tokens, idx, options, env);
    };
    md.renderer.rules.strong_close = (tokens, idx, options, env) => {
        if(tokens.length > 0) {
            const token = tokens[idx-1];
            if(token.type === 'text' && /^[\d#+]+$/.test(token.content)) {
                return '**';
            }
        }
        return originalStrongCloseRenderer(tokens, idx, options, env);
    };

    const originalEmOpenRenderer = md.renderer.rules.em_open;
    const originalEmCloseRenderer = md.renderer.rules.em_close;

    md.renderer.rules.em_open = (tokens, idx, options, env) => {
        if(tokens.length >= idx+1) {
            const token = tokens[idx+1];
            if(token.type === 'text' && /^[\d#+]+$/.test(token.content)) {
                return '*';
            }
        }
        return originalEmOpenRenderer(tokens, idx, options, env);
    };
    md.renderer.rules.em_close = (tokens, idx, options, env) => {
        if(tokens.length > 0) {
            const token = tokens[idx-1];
            if(token.type === 'text' && /^[\d#+]+$/.test(token.content)) {
                return '*';
            }
        }
        return originalEmCloseRenderer(tokens, idx, options, env);
    };
}
